var $ = require('../internals/export');

var DESCRIPTORS = require('../internals/descriptors');

var create = require('../internals/object-create'); // `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create


$({
  target: 'Object',
  stat: true,
  sham: !DESCRIPTORS
}, {
  create: create
});